module.exports = __webpack_public_path__ + "html/gallery.template.html";